import { Table } from "react-bootstrap";
import { Form, useNavigate } from "react-router-dom";
import classes from './drCheckList.module.css';
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import WaitingContext from "../../../store/waitingListContext";
import PatientModal from "../../UI/PatientModal";
import { useContext } from "react";
import AuthContext from "../../../store/auth-context";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import Loader from "../../UI/Loader";

import { useTranslation } from "react-i18next";
import ConfirmModal from "../../UI/ConfirmModal";

const DrCheckUpList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const chechUpContext = useContext(WaitingContext);
  const [searchPara, setSearchPara] = useState('');
  const [errorMessage, setErrorMsg] = useState('');
  const [checkUpData, setCheckUpData] = useState([]);
  const [patientData, setPatientData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deletePatient, setIsDeletedPatient] = useState([]);
  const [filteredCheckUpData, setFilteredCheckUpData] = useState([]);
  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [patientToDelete, setPatientToDelete] = useState(null);
  useEffect(() => {
    fetchCheckUpList();
  }, [deletePatient]);
  const fetchCheckUpList = async () => {
    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
      navigate('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/waitingList/getTodaysAllPatientForCheckUp`;
    setIsLoading(true);
    try {
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could Not fetch details");
      }
      const checkUpData = await response.json();

      // Filter by doctor if the logged-in user is a doctor
      let filteredData = checkUpData;
      if (authCtx.role === 'ROLE_DOCTOR') {
        filteredData = checkUpData.filter(p => p.doctorId?.userId === Number(authCtx.userId));
      }

      setCheckUpData(checkUpData);
      setFilteredCheckUpData(filteredData);
    } catch (error) {
      console.error("Error fetching checkup list data: ", error);
    }
    finally {
      setIsLoading(false); // Hide loader after fetching data
    }
  };
  const patientCheckupDetailsHandler = (e, checkUpPatient) => {
    e.preventDefault();
    chechUpContext.OnAddedcheckUp(checkUpPatient);
    navigate('checkpatient');
  }
  const removePatientFromDrCheckupList = (e, checkUpPatient) => {
    e.preventDefault();
    setPatientToDelete(checkUpPatient);
    setShowConfirmModal(true);
  };

  const confirmDeleteHandler = async () => {
    if (!patientToDelete) return;

    const checkUpPatient = patientToDelete;
    const token = getAuthToken();
    const apiChar = getApiChara();
    const waitingListId = checkUpPatient.waitingListId;
    const fetchApi = `${apiChar}/waitingList/deleteWaitingList/${waitingListId}`;
    setIsLoading(true);

    try {
      const response = await fetch(fetchApi, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // some DELETE APIs return no JSON, so handle safely
      let data = null;
      try {
        data = await response.json();
      } catch (_) {
        data = { success: true };
      }

      toast.success(
        t("Patient {{name}} removed from waiting list.", { name: `${checkUpPatient?.patientId?.firstName} ${checkUpPatient?.patientId?.lastName}` })
      );

      // update frontend list without refresh
      setCheckUpData((prev) =>
        prev.filter((p) => p.waitingListId !== waitingListId)
      );
      setFilteredCheckUpData((prev) =>
        prev.filter((p) => p.waitingListId !== waitingListId)
      );

      setIsDeletedPatient(data);
    } catch (error) {
      toast.error(t("Patient could not be deleted"));
      console.error("Error deleting patient: ", error);
    } finally {
      setIsLoading(false);
      setShowConfirmModal(false);
      setPatientToDelete(null);
    }
  };

  const onSearchPatientHandler = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setIsLoading(true);
    try {
      const token = getAuthToken();
      if (token === null || token === 'EXPIRED') {
        navigate('/');
      }
      const apiChar = getApiChara();
      const apiUrl = `${apiChar}/patient/getPatientByFNameOrLNameOrMobile?value=` + searchPara;

      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could not fetch details");
      }

      const data = await response.json();
      setPatientData(data);
    } catch (error) {
      console.error("Error occurred during search:", error);
      setErrorMsg(t("Could not fetch patient details. Please try again."));
    } finally {
      setIsLoading(false);
    }
  };
  const getSerachParaHandler = (e) => {
    setSearchPara(e.target.value);
  };
  const onDataCloseHandler = () => {
    setPatientData([]);
    navigate(".");
  }
  const refreshTableData = () => {
    fetchCheckUpList();
  };
  const newPatientHandler = () => {
    navigate("new");
  };
  return (
    <>
      {isLoading && <Loader />}
      {patientData && patientData.length > 0 && (
        <PatientModal
          patientData={patientData}
          OnCloseModalBlock={onDataCloseHandler}
          checkUpData={checkUpData}   // ✅ pass current checkup list here
        />
      )}
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
          <h4 style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>
            <i className="fa fa-users me-2"></i> {t("Todays Patients")}
          </h4>
          <span className="badge bg-light text-dark border p-2" style={{ fontSize: '0.85rem' }}>
            <i className="fa fa-calendar me-1" style={{ color: 'var(--primary-color)' }}></i> {formattedDate}
          </span>
        </div>

        <div className="row g-3 align-items-center mb-4">
          <div className="col-md-6">
            <form onSubmit={onSearchPatientHandler}>
              <div className="input-group">
                <span className="input-group-text bg-white border-end-0">
                  <i className="fa fa-search text-muted"></i>
                </span>
                <input
                  type="text"
                  className="form-control border-start-0 ps-0"
                  placeholder={t("Search by Name or Mobile...")}
                  value={searchPara}
                  onChange={getSerachParaHandler}
                  style={{ boxShadow: 'none' }}
                />
                <button
                  className={classes.searchBtn}
                  type="submit"
                >
                  <i className="fa fa-search me-2"></i> {t("Search")}
                </button>
                <button
                  type="button"
                  className={classes.refreshButton}
                  onClick={refreshTableData}
                  title={t("refresh patient list")}
                  style={{ marginLeft: '10px' }}
                >
                  <i className="fa fa-refresh"></i>
                </button>
              </div>
            </form>
          </div>
          <div className="col-md-6 d-flex justify-content-end gap-2 flex-wrap">
            <button
              className={classes.newPatientBtn}
              onClick={newPatientHandler}
            >
              <i className="fa fa-user-plus"></i> {t("New Patient")}
            </button>
          </div>
        </div>
      </div>

      <div className={classes.coverp}>
        <div className={classes.tableContainer}>
          <Table responsive hover className={classes.customTable}>
            <thead>
              <tr>
                <th style={{ width: '80px' }}>{t("Sr. No.")}</th>
                <th>{t("Patient Name")}</th>
                <th>{t("Weight")}</th>
                <th>{t("BP (Sys/Dys)")}</th>
                <th>{t("Temp")}</th>
                <th>{t("Pulse")}</th>
                <th>{t("Status")}</th>
                <th style={{ width: '150px' }}>{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredCheckUpData.length === 0 && (
                <tr>
                  <td colSpan="8" className='py-5 text-center text-muted'>
                    <i className="fa fa-folder-open fa-2x mb-2 d-block opacity-50"></i>
                    {t("No Patients in the waiting list today.")}
                  </td>
                </tr>
              )}
              {filteredCheckUpData.map((checkUpPatient) => (
                <tr key={checkUpPatient?.waitingListId}
                  className={`${checkUpPatient?.checkUpStatus === "CHECK_UP" ? classes.greenBackground : ''}`}
                >
                  <td><span className="badge rounded-pill bg-light text-dark border">{checkUpPatient?.serialNo}</span></td>
                  <td className="fw-500 text-start ps-4">
                    {`${checkUpPatient?.patientId?.firstName || ""} ${checkUpPatient?.patientId?.middleName ? checkUpPatient.patientId.middleName + " " : ""}${checkUpPatient?.patientId?.lastName || ""}`.trim()}
                  </td>
                  <td>{checkUpPatient?.weight ? `${checkUpPatient.weight} kg` : "-"}</td>
                  <td>
                    {checkUpPatient?.bp1 || checkUpPatient?.bp2
                      ? `${checkUpPatient?.bp1 || "-"}/${checkUpPatient?.bp2 || "-"}`
                      : "-"}
                  </td>
                  <td>{checkUpPatient?.temperature ? `${checkUpPatient.temperature} °F` : "-"}</td>
                  <td>{checkUpPatient?.pulse ? `${checkUpPatient.pulse} bpm` : "-"}</td>
                  <td>
                    {checkUpPatient?.checkUpStatus === "CHECK_UP" ? (
                      <span className="badge bg-success-subtle text-success border border-success-subtle px-1" style={{ fontSize: '10px' }}>{t("Ready")}</span>
                    ) : (
                      <span className="badge bg-warning-subtle text-warning border border-warning-subtle px-1" style={{ fontSize: '10px' }}>{t("Waiting")}</span>
                    )}
                  </td>
                  <td>
                    <div className={classes.actionButtons}>
                      <button
                        className={`${classes.actionBtnPremium} ${classes.checkUpAction}`}
                        onClick={(e) => patientCheckupDetailsHandler(e, checkUpPatient)}
                        title={t("Check Up")}
                      >
                        {t("Check Up")}
                      </button>
                      <button
                        className={`${classes.actionBtnPremium} ${classes.deleteAction}`}
                        onClick={(e) => removePatientFromDrCheckupList(e, checkUpPatient)}
                        title={t("Delete")}
                      >
                        <i className="fa fa-trash-o"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={confirmDeleteHandler}
        title={t("Delete Patient")}
        message={t("Are you sure you want to remove {{name}} from the waiting list?", {
          name: patientToDelete ? `${patientToDelete?.patientId?.firstName} ${patientToDelete?.patientId?.lastName}` : ""
        })}
        variant="danger"
        isLoading={isLoading}
      />
    </>
  );
}

export default DrCheckUpList;
